/**
 *
 *  Ask Concierge Modal for Homepage
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 04/10/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useState } from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";

import useTheme from "../../ThemeProvider/useTheme/useTheme";

// Components
import Button from "../../Button/Button";

// Icons
import ArrowRightIcon from "../../../icons/ArrowRightIcon";
import PhoneIcon from "../../../icons/PhoneIcon";
import EnvelopeIcon from "../../../icons/EnvelopeIcon";

// Utils
import { clientWidth } from "../../../utils";
import { modalStyles } from "../../../constants";

// Images
import askConcierge from "./ask-concierge.svg";

const AskConciergeModal = ({
  text = "Contact to let us help you to find the best Coach for your needs.",
  email = "members@trubeapp.com",
  isOpen,
  onClose,
}) => {
  const { theme } = useTheme();

  const customStyle =
    clientWidth() < theme.responsive.breakpoints.sm
      ? modalStyles.newMobileDefault
      : modalStyles.default;

  const [isModalOpen, setIsModalOpen] = useState();

  const modalResolveRef = React.useRef();

  const openModal = () => {
    return new Promise((resolve) => {
      modalResolveRef.current = resolve;

      setIsModalOpen(true);
    });
  };

  const closeModal = () => {
    if (modalResolveRef.current) {
      modalResolveRef.current();
      modalResolveRef.current = null;

      onClose();
    }

    setIsModalOpen(false);
  };

  return (
    <Modal
      appElement={/*__CLIENT__ && */ document.getElementById("#app")}
      isOpen={isOpen}
      // onRequestClose={closeModal}
      style={customStyle}
      contentLabel="Ask Concierge modal"
    >
      <div className="tbk-flex tbk-h-full tbk-flex-col tbk-rounded-2xl tbk-bg-basic-white tbk-p-3 lg:tbk-p-0">
        <div className="tbk-grow">
          <img
            className="tbk-h-28 tbk-w-28"
            src={askConcierge}
            alt="Ask TruBe Concierge"
          />
          <div className="tbk-text-h2-black tbk-mt-5 tbk-mb-1 tbk-text-primary">
            TruBe Concierge
          </div>
          <p className="tbk-text-main !tbk-leading-none_ tbk-my-4 tbk-text-blue-dark">
            {text}
          </p>
          {/*<p className="tbk-text-h3-subtitle tbk-mb-2 tbk-text-primary">
            <PhoneIcon className="tbk-mr-1 tbk-text-blue-grey" />
            <a
              href="tel:2098626606"
              className="tbk-inline-flex tbk-text-primary"
            >
              (209)862-6606
              <ArrowRightIcon className="tbk-ml-1 tbk-text-coral" />
            </a>
          </p>*/}
          <p className="tbk-text-h3-subtitle tbk-mb-5 tbk-text-primary">
            <EnvelopeIcon className="tbk-mr-1 tbk-text-blue-grey" />
            <a
              href={`mailto:${email}`}
              className="tbk-inline-flex tbk-text-primary"
            >
              {email}
              <ArrowRightIcon className="tbk-ml-1 tbk-text-coral" />
            </a>
          </p>
        </div>
        <Button
          variant="secondary"
          className="tbk-w-full"
          onClick={() => onClose()}
        >
          Close
        </Button>
      </div>
    </Modal>
  );
};

AskConciergeModal.displayName = "AskConciergeModal";
AskConciergeModal.propTypes = {
  heroRef: PropTypes.object.isRequired,
};
AskConciergeModal.defaultProps = {
  showLinks: true,
  showMenu: true,
};

export default AskConciergeModal;
